import VueI18n from 'vue-i18n';
import Vue from "vue"
import store from "../store"
import pt from "../languages/pt"
import es from "../languages/es"
import en from "../languages/en"

Vue.use(VueI18n);
const messages = {
  'en': en,
  'es': es,
  'pt': pt
};

let lang = ""

// Verifica se Existe Language armazenada
if (store.state.language != "") {
  localStorage.setItem('language', store.state.language);
  lang = store.state.language
} else {
  let language = navigator.language
  localStorage.setItem('language', language.slice(0, 2));
  lang = language.slice(0, 2)
}

const acceptedLanguages = ["es", "en", "pt"];

if (!acceptedLanguages.includes(lang)) {
  lang = "en";
  localStorage.setItem('language', lang);
}

store.commit("setLanguage", lang);

const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: lang, // set fallback locale
  messages, // set locale messages
});


export default i18n;